<template>
  <div />
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'AuthRedirect',

  mounted () {
    if (this.$route.query.token) {
      const token = this.$route.query.token
      this.setBearerToken(token)
      this.$router.push('/admin-dashboard')
    } else {
      this.$router.push('/login')
    }
  },

  methods: {
    ...mapMutations(['setBearerToken'])
  }
}
</script>
